import { Injectable } from '@angular/core';
import { CanActivate, Router,RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { Auth } from 'aws-amplify';

@Injectable({
  providedIn: 'root'
})

export class AuthGuard implements CanActivate {

  constructor(private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise < boolean > {
    return new Promise((resolve) => {
      Auth.currentAuthenticatedUser({
          bypassCache: false
        })
        .then((user) => {
          if(user){
            console.log("AuthGuard Cognito User", user);

            localStorage.setItem("userId", user.attributes.sub);
            
            resolve(true);
          }
        })
        .catch(() => {
          resolve(false);
          localStorage.removeItem("userId");

          this.router.navigateByUrl('/home'); 
          //console.log('Pulled from master & dev'); 
        });
    });
  }
}